import { render, staticRenderFns } from "./DataBaseEditor.vue?vue&type=template&id=45f8428d&scoped=true&"
import script from "./DataBaseEditor.vue?vue&type=script&lang=ts&"
export * from "./DataBaseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DataBaseEditor.vue?vue&type=style&index=0&id=45f8428d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8428d",
  null
  
)

export default component.exports